import { render, staticRenderFns } from "./WSurveyAnswers.vue?vue&type=template&id=1aaaf6fc&"
import script from "./WSurveyAnswers.vue?vue&type=script&lang=ts&"
export * from "./WSurveyAnswers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports